/*
 * Copyright (c) 2019. Nedaware SL
 */


import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {Resource} from "../../api/resource";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {FORMATS} from "../../basic-entity-front/const";
import * as moment from "moment";

/**
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
@BasicEntity({
    name: 'Festivos',
    endpoint: 'festivos',
    isPaginated: true,
    acceptsBulkIriSearch: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'nombreFecha',
    type: 'Festivo'
})
export class Festivo extends Resource {
    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _idFestivo: number;

    @BasicProperty({
        name: 'Nombre',
        type: PropertyType.String()
    })
    private _nombreFestivo: string;

    @BasicProperty({
        name: 'Fecha',
        type: PropertyType.Date(),
        sortable: true
    })
    private _fechaFestivo: moment.Moment;

    @BasicProperty({
        type: PropertyType.String(),
        readWrite: ReadWrite.ReadOnly,
        dontReadFromApi: true
    })
    /**
     * Es el modelNameProperty: lo lee BasicEntityInterface.getName() para el listado y para el
     * diálogo de borrado. La fecha llega como moment, que es lo que devuelve el MomentCaster de
     * PropertyType.Date(); el DateTime de luxon que declaraba antes venía de una versión vieja
     * del proyecto y hacía que borrar un festivo reventara con "toFormat is not a function".
     */
    get nombreFecha(): string {
        return this._fechaFestivo
            ? `${this._nombreFestivo} (${this._fechaFestivo.format(FORMATS.date)})`
            : this._nombreFestivo;
    }

    get idFestivo(): number {
        return this._idFestivo;
    }

    set idFestivo(value: number) {
        this._idFestivo = value;
    }

    get nombreFestivo(): string {
        return this._nombreFestivo;
    }

    set nombreFestivo(value: string) {
        this._nombreFestivo = value;
    }

    get fechaFestivo(): moment.Moment {
        return this._fechaFestivo;
    }

    set fechaFestivo(value: moment.Moment) {
        this._fechaFestivo = value;
    }
}
